import { render, staticRenderFns } from "./HrSalaryGrantDetail.vue?vue&type=template&id=0683a01c&scoped=true&"
import script from "./HrSalaryGrantDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryGrantDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryGrantDetail.vue?vue&type=style&index=0&id=0683a01c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683a01c",
  null
  
)

export default component.exports